import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Network, MessageCircle, ArrowRight } from "lucide-react";
import { api, storeLogoUrl } from "@/api";

// Halaman mitra: /mitranet/mitra/{slug} — slug = slug TOKO existing (tenant buatan Superadmin).
// Memakai data stores existing via endpoint publik; TANPA entitas/collection baru.
// Route lama /toko/:slug tetap berjalan tanpa perubahan.
export default function MitraPage() {
  const { slug } = useParams();
  const s = (slug || "").toLowerCase();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setData(null); setErr(false);
    api.get(`/public/stores/${s}`).then((r) => setData(r.data)).catch(() => setErr(true));
  }, [s]);

  return (
    <div className="app-shell" data-testid="mitra-page">
      <div className="container" style={{ maxWidth: 560 }}>
        <header className="app-header" style={{ justifyContent: "center", textAlign: "center" }}>
          <div>
            <h1 className="app-title" style={{ justifyContent: "center" }}>
              <Network size={26} className="title-icon" /> MITRAnet
            </h1>
            <p className="app-subtitle">by RAMACOM — PT. Lintas Jaringan Nusantara</p>
          </div>
        </header>

        {!data && !err && <p className="center-note" data-testid="mitra-loading">Memuat data mitra...</p>}

        {err && (
          <div className="panel" style={{ textAlign: "center", padding: 28 }} data-testid="mitra-notfound">
            <h2 style={{ margin: "0 0 6px" }} data-testid="mitra-slug">{s}</h2>
            <p className="muted-sm">Mitra dengan slug ini tidak ditemukan atau sedang tidak aktif.</p>
            <Link to="/" className="link-btn" data-testid="mitra-back-home" style={{ display: "inline-block", marginTop: 8 }}>Kembali ke halaman utama</Link>
          </div>
        )}

        {data && data.store && (
          <div className="panel" style={{ textAlign: "center", padding: 28 }} data-testid="mitra-card">
            {data.store.logo_path ? (
              <img src={storeLogoUrl(data.store)} alt={`Logo ${data.store.store_name}`} className="store-logo" style={{ width: 72, height: 72, margin: "0 auto 10px" }} data-testid="mitra-store-logo" />
            ) : (
              <div className="store-logo store-logo-default" style={{ width: 72, height: 72, fontSize: 30, margin: "0 auto 10px" }} data-testid="mitra-store-logo-default">{(data.store.store_name || "?").trim().charAt(0).toUpperCase()}</div>
            )}
            <p className="muted-sm" style={{ margin: 0 }}>Mitra MITRAnet</p>
            <h2 style={{ margin: "6px 0 4px" }} data-testid="mitra-store-name">{data.store.store_name}</h2>
            {data.store.subtitle && <p className="muted-sm" data-testid="mitra-store-subtitle">{data.store.subtitle}</p>}
            <p className="muted-sm" data-testid="mitra-url" style={{ marginTop: 4 }}>/mitranet/mitra/{s}</p>
            <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap", marginTop: 16 }}>
              <Link to={`/toko/${s}`} className="btn-primary sm" data-testid="mitra-open-store" style={{ display: "inline-flex", alignItems: "center", gap: 6, textDecoration: "none" }}>
                Buka Halaman Toko <ArrowRight size={14} />
              </Link>
              {data.store.whatsapp_number && (
                <a className="btn-ghost sm" data-testid="mitra-wa" href={`https://wa.me/${data.store.whatsapp_number}`} target="_blank" rel="noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                  <MessageCircle size={14} /> WhatsApp
                </a>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
